module.exports = __webpack_public_path__ + "img/fullSideAmbulanceImage.fd2341b6.jpg";